/**
 * Created by BFR on 23/05/2017.
 */
define('restransDetailView',[
  'module',
  'restransCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!restransDetailTabTpl',
  'settings',
  'moment'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl,
  Settings,
  moment
) {
  'use strict';

  var ResTransDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();

      templateData.expDt = moment(this.model.get('expDt')).format('DD-MM-YYYY');
      templateData.prodDt = moment(this.model.get('prodDt')).format('DD-MM-YYYY');
      templateData.currentCAccountSecId = Settings.get('currentCAccount').secId;
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        restransModel: this.model
      });
      createEditView.show({
        title: _.i18n('restrans.edit')
      });
    }

  });

  module.exports = ResTransDetailView;
});
